export default __webpack_public_path__ + "static/globe-data-points-9e8b45313c9c7078f104d229e712ad70.mp4";